import styled from "styled-components";

export const PreloaderStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30vh;
`;
